import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'
import { siteConfig } from '@/constants/site'

interface LogoMarkProps {
    className?: string
}

export const LogoMark: FC<LogoMarkProps> = ({ className }): ReactNode => {
    return (
        <svg viewBox='0 0 32 32' className={cn('size-9 shrink-0', className)} aria-hidden='true'>
            <rect width='32' height='32' rx='8' fill='#2194D2' />
            <path d='M32 18v6a8 8 0 0 1-8 8H8a8 8 0 0 1-6.9-4C9 29 22 26 32 18z' fill='#176A98' fillOpacity='.55' />
            <path d='M16 8.2 11.3 10.1M16 8.2l4.7 1.9' stroke='#fff' strokeOpacity='.75' strokeWidth='1.2' strokeLinecap='round' />
            <circle cx='16' cy='8.2' r='2.1' fill='#fff' />
            <circle cx='11.1' cy='10.2' r='1.25' fill='#fff' fillOpacity='.85' />
            <circle cx='20.9' cy='10.2' r='1.25' fill='#fff' fillOpacity='.85' />
            <path d='M7 13.4c2.8-1.1 5.6-.9 8.2.7v10.2c-2.6-1.6-5.4-1.8-8.2-.7z' fill='#fff' />
            <path d='M25 13.4c-2.8-1.1-5.6-.9-8.2.7v10.2c2.6-1.6 5.4-1.8 8.2-.7z' fill='#fff' fillOpacity='.72' />
        </svg>
    )
}

interface LogoProps {
    compact?: boolean
    tone?: 'default' | 'light'
    className?: string
}

export const Logo: FC<LogoProps> = ({
    compact = false,
    tone = 'default',
    className
}): ReactNode => {
    return (
        <span className={cn('flex items-center gap-2.5', className)}>
            <LogoMark />

            {!compact && (
                <span className='flex flex-col leading-tight'>
                    <span className={cn('text-[15px] font-extrabold', tone === 'light' ? 'text-white' : 'text-navy')}>
                        {siteConfig.shortName}
                    </span>

                    <span className={cn('text-caption font-medium', tone === 'light' ? 'text-white/70' : 'text-muted-foreground')}>
                        {siteConfig.organization}
                    </span>
                </span>
            )}
        </span>
    )
}
